<template>
  <el-dialog
    class="listDialog no-header-dialog"
    :visible.sync="visible"
    width="40%"
    :before-close="cancel"
  >
    <div class="title">上传{{title}}纪要</div>
    <div class="wrap">
      <div class="content">
        <div class="text must">内容:</div>
        <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="textarea"></el-input>
      </div>
      <div class="pics">
        <div class="text">图片:</div>
        <div>
          <el-upload
            action="#"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-change="handleChange"
            :on-remove="handleRemove"
            :limit="9"
            :auto-upload="false"
            :file-list="uploadedlist"
          >
            <i class="el-icon-plus" v-show="uploadedlist.length < 9"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
          <div class="limit">(最多上传9张)</div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="okay">确认上传</el-button>
    </span>
    <!-- 样式在override.less -->
    <div class="overallCircleClose" @click="cancel">
      <img src="../../../assets/img/event/close.png" alt />
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { APIMAP } from "@/constants/apiConstants";
import { getServerData } from "@/utils/fetchData";
export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      textarea: "",
      dialogVisible: false,
      dialogImageUrl: "",
      disabled: false,
      uploadedlist: [],
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  watch: {
    visible(newVal) {
      if (!newVal) {
        this.textarea = "";
        this.uploadedlist = [];
      }
    },
  },
  methods: {
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 文件移除
    handleRemove(file) {
      console.log(file);
      this.uploadedlist = this.uploadedlist.filter(
        (item) => item.myurl !== file.myurl
      );
    },

    okay() {
      if (!this.textarea.trim()) {
        this.$message({
          message: "请填写内容",
          type: "warning",
        });
        return;
      }
      // else if (!this.uploadedlist.length) {
      //   this.$message({
      //     message: "请上传图片",
      //     type: "warning",
      //   });
      //   return;
      // }
      const tempList = this.uploadedlist.map((item) => (item = item.myurl));
      console.log(tempList);
      this.$emit("getimglist", tempList, this.textarea);
      this.$emit("dialog-cancel");
    },
    cancel() {
      this.$emit("dialog-cancel");
    },
    async handleChange(file, filelist) {
      console.log(file, filelist);
      if (filelist.length === 0) return;
      // const formData = new FormData();
      // formData.append("file", file.raw);
      try {
        const res = await getServerData(
          APIMAP.UPLOAD,
          {
            file: file.raw,
            pid: this.userInfo.platformid,
            type: "1",
          },
          "post",
          0,
          true
        );
        console.log(res);
        const { url } = res;
        // const obj = {};
        // obj.id = file.uid;
        // obj.url = url;
        // this.uploadedlist.push(obj);
        this.uploadedlist = [...this.uploadedlist, { ...file, myurl: url }];
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.listDialog {
  .title {
    height: 60px;
    font-size: 16px;
    color: #2c3a50;
    background: #f4f7f9;
    line-height: 60px;
    text-align: center;
  }
  .wrap {
    padding: 0 24px;
    font-size: 16px;
    border-bottom: 1px solid #e2e5ec;
    position: relative;
    .content,
    .pics {
      display: flex;
      margin: 28px 0;
      position: relative;
      .text {
        width: 100px;
      }
      .must {
        &:before {
          content: "*";
          color: red;
          position: absolute;
          top: 4px;
          left: -10px;
          font-size: 12px;
        }
      }
      .limit {
        color: #838997;
        font-size: 15px;
        margin: 4px 0;
      }
    }
  }
  .dialog-footer {
    .el-button {
      width: 60%;
      margin-right: 20%;
    }
  }
  .z-index {
    z-index: 2 !important;
  }
}
</style>